import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';
import { SIZES } from 'tcomponents/atoms/FontIcon';
import IconAsBtn from 'tcomponents/atoms/iconAsBtn';
import Button from 'tcomponents/atoms/Button/Button';
import ToolTip from 'tcomponents/atoms/tooltip';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import styles from './TimesheetRemainder.module.scss';
import { usePusher } from './TimesheetRemainder.constants';
import { getPusherCred } from '../../molecules/Header/Header.selector';
import { getEmailId } from '../../utils/helper';
const TooltipContent = _ref => {
  let {
    setVisible
  } = _ref;
  const onHandleClick = useCallback(() => {
    setVisible(false);
  });
  return /*#__PURE__*/React.createElement("div", {
    className: styles.toolTipContent
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, __('Your timesheet is due for submission today')), /*#__PURE__*/React.createElement("div", {
    className: styles.buttons
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onHandleClick,
    className: styles.skipBtn
  }, __('Skip')), /*#__PURE__*/React.createElement("a", {
    href: "/timetracker/employee-view",
    onClick: onHandleClick,
    className: styles.submitBtn
  }, __('Submit'))));
};
TooltipContent.propTypes = {
  setVisible: PropTypes.func.isRequired
};
const pusherConfig = {
  channelName: 'private-tap-notification-',
  eventName: 'timesheet_remainder',
  authEndpoint: 'tapapi/tap_notification/public/v1/notification/pusher/auth'
};
const TimesheetRemainder = _ref2 => {
  let {
    apiBaseUrl,
    pusherCred
  } = _ref2;
  const [visible, setVisible] = useState(false);
  const {
    key,
    cluster,
    timesheetBaseUrl
  } = pusherCred;
  usePusher(_objectSpread(_objectSpread({}, pusherConfig), {}, {
    channelName: "".concat(pusherConfig.channelName).concat(getEmailId()),
    authEndpoint: "".concat(timesheetBaseUrl || apiBaseUrl, "/").concat(pusherConfig.authEndpoint),
    key,
    cluster
  }), () => {
    setVisible(true);
  });
  return visible ? /*#__PURE__*/React.createElement(ToolTip, {
    title: /*#__PURE__*/React.createElement(TooltipContent, {
      setVisible: setVisible
    }),
    visible: visible,
    overlayClassName: styles.TimesheetRemainder
  }, /*#__PURE__*/React.createElement(IconAsBtn, {
    size: SIZES.XL,
    style: {
      marginRight: '8px'
    }
  }, "icon-clock_reminder")) : /*#__PURE__*/React.createElement(React.Fragment, null);
};
TimesheetRemainder.propTypes = {
  apiBaseUrl: PropTypes.string.isRequired,
  pusherCred: PropTypes.object.isRequired
};
const mapStateToProps = createStructuredSelector({
  pusherCred: getPusherCred()
});
export default connect(mapStateToProps)(TimesheetRemainder);